import { render, staticRenderFns } from "./PageManager.vue?vue&type=template&id=74701f9a"
import script from "./PageManager.vue?vue&type=script&lang=ts"
export * from "./PageManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports